<template>
  <section class="content">
    <div class="row center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>

      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body">
            <ul class="nav nav-tabs" style="margin-bottom: 10px;">
              <li role="presentation" :class="{'active': tab == 1}" @click="updateQuery(1)">
                <a>商品</a>
              </li>
              <li role="presentation" :class="{'active': tab == 3}" @click="updateQuery(3)">
                <a>套餐</a>
              </li>
              <li role="presentation" :class="{'active': tab == 10}" @click="updateQuery(10)">
                <a>分類</a>
              </li>
              <!-- <li role="presentation" :class="{'active': tab == 99}" @click="updateQuery(99)">
                <a>菜單圖示</a>
              </li> -->
            </ul>
            <div class="p-t-10">
              <div class="btn btn-default btn-table-title" @click="crElement()">新增{{tabName}}別名/描述/警示</div>
            </div>
            <div class="p-t-50 m-t-15">
              <div class="col-xs-12 col-md-2 bg-light-gray text-left">
                <div 
                  class="select-element" 
                  v-for="option in subMenuList" 
                  :key="`option-${option.value}`"
                  :class="{'active': subMenu === option.value}" 
                  @click="clickSubMenu(option.value)"  
                  :disabled="subMenu === option.value"
                >
                  <span class="text-w-600 p-x-15">{{ option.text }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-10 p-l-10">
                <div class="flex justify-between">
                  <div class="form-inline">
                    <div class="form-group">
                      <select class="form-control h-38" v-model="searchType">
                        <option value="name">商品名稱</option>
                        <option value="id">商品料號</option>
                      </select>
                    </div>
                    <div class="form-group search-bar">
                      <div class="input-group">
                        <input class="form-control" type="text" v-model="searchText">
                        <span class="input-group-addon c-pointer" @click="search">
                          <i class="fa fa-search"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="text-center title">{{ subMenu === 'alias' ? '商品別名' : '商品描述/警語' }}</div>
                  <div class="text-right">
                    <button 
                      v-if="getRoleType !== 10 || getStores.length > 1" 
                      :disabled="!selectItems.length" 
                      class="btn btn-default" 
                      data-toggle="modal" 
                      data-target="#copyModal" 
                    >
                      複製選取設定至其他店家
                    </button>
                    <button 
                      :disabled="!selectItems.length" 
                      class="btn btn-danger" 
                      data-toggle="modal" 
                      data-target="#delDesAlisModal" 
                      @click="setDeleteItem"
                    >
                      批次刪除
                    </button>
                  </div>
                </div>
                <div class="row">
                  <prod-setting-table
                    :setting-list.sync="list"
                    :search-text="searchText"
                    :meta="meta"
                    :tab="tab"
                    :type="subMenu"
                    :tableIndex.sync="page"
                    @updatePagination="updatePagination"
                    @updateDel="updateDelElement"
                    @selectItem="setSelectItem"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delDesAlisOption" @trigger="trigger"></m-modal>
    <choose-store-modal @copyStore="copyStore" :option="storeOption"></choose-store-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ProdSettingTable from './Temp/ProdSettingTable'
import chooseStoreModal from '@/components/elements/chooseStoreModal.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'ProductSetting',
  data () {
    return {
      brandName: '',
      storeName: '',
      total: 1,
      count: 20,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      // tab 選擇
      tab: 1,
      list: [],
      iconList: [],
      meta: {
        total: 0,
        size: 20
      },
      delDesAlisOption: {
        id: 'delDesAlisModal',
        title: '刪除描述/別名/警語',
        body: '',
        btns: [
          {
            name: '取消',
            event: 'close'
          },
          {
            name: '確定',
            event: 'delProductSetting'
          }
        ]
      },
      storeOption: {
        id: 'copyModal'
      },
      delDesAlisId: 0,
      page: 1,
      searchType: 'name',
      searchText: '',
      selectItems: [],
      // 別名 or 描述/警語
      subMenu: 'alias',
      subMenuList: [
        {
          value: 'alias',
          text: '商品別名'
        },
        {
          value: 'description',
          text: '商品描述/警語'
        }
      ]
    }
  },
  extends: NdExtendHandleMenu,
  components: {
    'prod-setting-table': ProdSettingTable,
    'choose-store-modal': chooseStoreModal
  },
  methods: {
    setDeleteItem () {
      this.delDesAlisOption.btns[1].event = 'deleteSeleteItem'
    },
    updateQuery (tab) {
      this.tab = tab
      this.page = 1
      this.setRouterQuery()
    },
    setRouterQuery () {
      let query = {
        tab: this.tab,
        page: this.page,
        subMenu: this.subMenu
      }
      if (this.brandName && this.storeName) {
        query.brand_name = this.brandName
        query.store_name = this.storeName
      }
      if (this.searchType && this.searchText) {
        query.search_type = this.searchType
        query.search_text = this.searchText
      }
      this.$router.replace({ path: this.$route.path, query: query })
    },
    isActive (index) {
      if (this.page === index) return true
      else return false
    },
    editStores (menuId) {
      this.$router.push('/upSchedule/all/' + menuId)
    },
    checkDoubleStore (storeIdList) {
      var newScheduleList = []
      for (let key in storeIdList) {
        /*
        if (storeIdList[key].length === 1) {
          newScheduleList.push(storeIdList[key][0])
        } else {
          var combineSchedule = {}
          for (let i = 0; i < storeIdList[key].length; i++) {
            if (i === 0) {
              combineSchedule = storeIdList[key][i]
            } else {
              combineSchedule.values.push(storeIdList[key][i].values[0])
            }
          }
          newScheduleList.push(combineSchedule)
        }
        */
        newScheduleList.push(storeIdList[key][0])
      }
      this.setGantt(newScheduleList)
    },
    setSearchQuery () {
      // 設定搜尋條件
      let text = 'size=' + this.count + '&type=' + this.tab + '&page=' + this.page
      if (this.searchType && this.searchText && this.searchText.trim()) {
        text = text + (this.searchType === 'name' ? '&product_name=' : '&vendor_custom_id=') + this.searchText.trim()
      }
      return text
    },
    getList () {
      const urlName = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting'
      var url = `store/${this.$route.params.store_id}/${urlName}/list?${this.setSearchQuery()}`
      this.getDataH('get', url, null, (response) => {
        this.list = response.data.list
        this.meta = response.data.meta
      })
    },
    updatePagination (page) {
      this.page = page
      this.setRouterQuery()
      this.getList()
    },
    trigger (event) {
      if (event === 'close') {
        return
      } else if (event === 'delProductSetting') {
        this.delProductDesAlias()
      } else {
        this.batchDelet()
      }
    },
    setSelectItem (val) {
      // 選擇的項目
      this.selectItems = val
    },
    updateDelElement (id) {
      // 刪除單一項目
      this.delDesAlisId = id
      this.delDesAlisOption.btns[1].event = 'delProductSetting'
    },
    batchDelet () {
      // 批次刪除
      if (this.selectItems.length) {
        const urlType = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting'
        const url = `store/${this.$route.params.store_id}/${urlType}/batchDelete?setting_ids=${this.selectItems.toString()}`
        this.getDataH('delete', url, null, (response) => {
          if (response.data.status === 200) {
            this.$notify({
              title: '成功',
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            this.getList()
          }
          this.clearSelect()
        })
      }
    },
    search () {
      // 搜尋
      this.page = 1
      this.setRouterQuery()
      this.getList()
    },
    crElement () {
      const bId = this.$route.params.brand_id
      const sId = this.$route.params.store_id
      this.$router.push(`/crProductSetting/${bId}/${sId}?tab=${this.tab}`)
    },
    delProductDesAlias () {
      // 刪除商品別名或描述
      if (this.delDesAlisId) {
        const urlType = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting'
        const url = `store/${this.$route.params.store_id}/${urlType}/${this.delDesAlisId}`
        this.getDataH('delete', url, null, (response) => {
          if (response.data.status === 200) {
            this.$notify({
              title: '成功',
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            this.getList()
          }
          this.clearSelect()
        })
      }
    },
    clearSelect () {
      this.delDesAlisId = null
      this.list.forEach(element => {
        element.selectItem = false
      })
    },
    copyStore (storeList) {
      // 同步多門市商品別名或商品描述設定
      const urlName = this.subMenu === 'alias' ? 'productAliasSetting' : 'productDescriptionSetting'
      if (storeList.length) {
        const url = `/store/${this.$route.params.store_id}/${urlName}/storeSync`
        const data = {
          store_id_list: storeList,
          setting_id_list: this.selectItems,
          type: this.tab
        }
        this.getDataH('post', url, data, (response) => {
          if (response.data.status === 200) {
            this.$notify({
              title: `複製${this.subMenu === 'alias' ? '別名' : '描述/警語'}成功`,
              duration: 3000,
              type: 'success',
              width: 400
            })
            this.clearSelect()
          }
        })
      }
    },
    clickSubMenu (val) {
      // 點擊側邊欄 (別名 or 描述/警語)
      this.subMenu = val
      this.list = []
      this.updatePagination(1)
    },
    async getStoreInfo () {
      var url = '/store/' + this.$route.params.store_id + '/info'
      await this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const storeInfo = response.data.info
          this.brandName = storeInfo.brand_name
          this.storeName = storeInfo.name
          this.$router.replace({
            query: {
              ...this.$route.query,
              brand_name: this.brandName,
              store_name: this.storeName
            }
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getStores']),
    tabName () {
      switch (this.tab) {
        case 2: return '配料'
        case 20: return '配料群組'
        case 10: return '商品分類'
        case 1: return '商品'
        case 11: return '品項選擇區'
        case 3: return '套餐'
      }
    },
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        })
      }
      return menuList
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    // 若無 query, 則初始化
    $route: {
      handler () {
        if (!Object.keys(this.$route.query).length) {
          this.updateQuery(1)
        }
      },
      immediate: true
    },
    '$route.query.tab' (val) {
      this.tab = parseInt(val, 10)
      this.page = 1
      this.searchText = ''
      this.getList()
    }
  },
  async created () {
    if (Object.keys(this.$route.query).length) {
      this.page = parseInt(this.$route.query.page, 10) || 1
      this.tab = parseInt(this.$route.query.tab, 10)
      this.subMenu = this.$route.query.subMenu || 'alias'
      // 顯示 {品牌名稱 - 門市名稱}
      if (!this.$route.query.brand_name || !this.$route.query.store_name) {
        await this.getStoreInfo()
      } else {
        this.brandName = this.$route.query.brand_name
        this.storeName = this.$route.query.store_name
      }
      // 搜尋
      this.searchType = this.$route.query.search_type || 'name'
      this.searchText = this.$route.query.search_text || ''
      this.setRouterQuery()
      this.getList()
    }
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  }
}
</script>

<style lang="sass" scoped>
$default-color: #e1456d
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc

.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
.t-5
  top: 5px
.btn-black, .btn-black:hover, .btn-black:focus, .btn-black:active, .btn-black:active:focus
  border: 1px solid #333333 !important
.m-r-10
  margin-right: 10px
.p-r-5
  padding-right: 5px !important
.p-l-5
  padding-left: 5px !important
.box-body.menu-form
  left: 0
  width: auto
  padding: 0px 10px
.btn-options
  width: 100%
  padding: 8px 0px
  color: $default-color
  background: #ffffff
  border: solid 1px $default-color
  border-radius: 5px
.btn.disabled, .btn[disabled], fieldset[disabled] .btn
  cursor: auto
  opacity: 1
.c-auto
  cursor: auto !important
.label-notice-number
  background: #e1456d
  border-radius: 5px
  font-size: 15px
  color: #fff
  padding: 4px 12px
  font-weight: bold
  top: -2px
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.select-element-block
  margin-bottom: 10px
  max-height: calc(100vh - 360px)
  overflow: scroll
@media screen and (max-width: 767px)
  .select-element
    padding: 5px 15px
    font-size: 16px
  .select-element-block
    margin-left: 10px
    margin-right: 10px
    height: 30vh
</style>



// WEBPACK FOOTER //
// ProductSetting.vue?3a76ab82